const style = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  head: ({ size }) => ({
    padding: `${size(3.5)} ${size(4)}`
  }),
  bank: ({ size }) => ({
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    padding: `0 ${size(4)}`,
    minHeight: '0'
  }),
  words: ({ size, printMode }) => ({
    flex: '1',
    display: 'grid',
    gap: size(2),
    overflowY: printMode ? 'hidden' : 'auto'
  }),
  titles: ({ size }) => ({
    display: 'grid',
    gap: size(2)
  }),
  groupTitle: ({ size }) => ({
    fontSize: size(2.5, { scaleFactor: 'sm' }),
    lineHeight: '1.2',
    margin: `0 0 ${size(2)}`,
    textAlign: 'center'
  }),
  group: ({ size }) => ({
    paddingBottom: size(3)
  }),
  randomBank: ({ size, printMode }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1',
    padding: `0 ${size(4)}`,
    minHeight: '0',
    overflow: printMode ? 'hidden' : 'auto'
  }),
  randomBankHolder: ({ size }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: size(3),
    margin: 'auto 0'
  })
}

const wordStyles = {
  word: ({ size, printMode }) => ({
    padding: printMode
      ? '8px 4px'
      : `${size(1.5, { scaleFactor: 'sm' })} ${size(1)}`,
    textAlign: 'center',
    background: '#00afec',
    borderRadius: size(0.5, { scaleFactor: 'sm' }),
    color: '#fff',
    marginBottom: printMode ? '8px' : size(2),
    fontSize: printMode ? '14px' : size(2, { scaleFactor: 'sm' }),
    fontWeight: 'bold',
    lineHeight: '1.2'
  }),
  random: ({ size, printMode }) => ({
    minWidth: size(26),
    margin: printMode ? '8px' : size(1.4),
    padding: printMode
      ? '8px 4px'
      : `${size(1.5, { scaleFactor: 'sm' })} ${size(1.5)}`
  })
}

export { wordStyles }

export default style
